import { render, staticRenderFns } from "./TransactionAccount.vue?vue&type=template&id=49893d47&"
import script from "./TransactionAccount.vue?vue&type=script&lang=js&"
export * from "./TransactionAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports